import { Capacitor } from '@capacitor/core';
import { f7 } from 'framework7-react';

export function copyPhoneAndPromptCall(
  phone: string,
  copiedText: string,
  callText: string,
  dismissText: string,
): void {
  void navigator.clipboard?.writeText(phone);
  f7.dialog
    .create({
      text: copiedText,
      buttons: [
        { text: dismissText, close: true },
        {
          text: callText,
          close: true,
          onClick() {
            window.location.href = `tel:${phone}`;
          },
        },
      ],
    })
    .open();
}

/**
 * Click handler for `tel:` / `sms:` quick-action links.
 *
 * On a phone (native Capacitor build) the scheme is real - let the `<a href>`
 * open the dialer / Messages app and do nothing else. On desktop (web) those
 * schemes are dead and tapping them looks broken, so intercept the click, copy
 * the number to the clipboard, and confirm with a toast. The `<a>` must keep the
 * `external` class so Framework7 doesn't swallow the click on native.
 */
export function handleContactLinkClick(
  e: React.MouseEvent,
  phone: string,
  copiedToast: string,
): void {
  if (Capacitor.isNativePlatform()) return; // native dialer / SMS app handles it
  e.preventDefault();
  void navigator.clipboard?.writeText(phone);
  f7.toast.show({ text: copiedToast, closeTimeout: 2000, position: 'bottom' });
}
